import React, { useState } from 'react'
import { Col, Input, Modal, Row } from 'antd'
import _, { isEmpty } from 'lodash'
import { useDeepEffect } from '../../utils/hooks'
import { ButtonEx, MaterialItem } from '../../shared.style'

const MaterialList = (props) => {
  const { visible, onOk, onClose, materials, materialState, setMaterialState } =
    props
  const [stateList, setStateList] = useState([])

  useDeepEffect(() => {
    if (!isEmpty(materials)) {
      setDefault()
    }
  }, [materials])

  function setDefault() {
    setStateList(materials)
  }

  function onClickItem(material) {
    if (material.id === materialState.materialId) {
      setMaterialState({})
    } else {
      setMaterialState((prevState) => {
        prevState.id = material.id
        prevState.name = material.name
        prevState.image = material.image
        prevState.unit = material.unit
        return { ...prevState }
      })
    }
  }

  function onSearch(e) {
    const { value } = e.target

    const arr = []

    if (value) {
      materials.forEach((item) => {
        const arr2 = []
        item.materialList.forEach((material) => {
          if (material.name.includes(value)) {
            arr2.push(material)
          }
        })
        arr.push({
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          materialList: arr2
        })
      })
      setStateList(arr)
    } else {
      setDefault()
    }
  }

  const renderItemActive = (item) => {
    let active = false
    if (materialState.id === item.id) {
      active = true
    }

    return active
  }

  return (
    <Modal
      destroyOnClose={true}
      width={800}
      title="เลือกวัสดุ"
      visible={visible}
      onOk={onOk}
      onCancel={onClose}
      footer={[
        <ButtonEx
          color="#6ebf4b"
          type="primary"
          key="ok"
          onClick={() => onOk()}>
          เลือก
        </ButtonEx>
      ]}>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Input.Search placeholder="ค้นหา" onChange={onSearch} />
        </Col>
        <Col span={24}>
          <Row style={{ height: 450, overflowY: 'scroll' }}>
            {!_.isEmpty(stateList) &&
              stateList.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                      {item.categoryName}
                    </span>
                    <Row>
                      {item.materialList.map((material, idx) => {
                        return (
                          <MaterialItem
                            key={idx}
                            active={renderItemActive(material)}
                            onClick={() => onClickItem(material)}>
                            {material.name}
                          </MaterialItem>
                        )
                      })}
                    </Row>
                  </Col>
                )
              })}
          </Row>
        </Col>
      </Row>
    </Modal>
  )
}

export default MaterialList



// WEBPACK FOOTER //
// ./src/components/MaterialList/index.js